import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import {
  Grid,
  Typography,
  Tooltip,
  TextField,
  Button,
  CardContent,
  LinearProgress,
  Backdrop,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { getCurrentDate } from "../functions/current";
import { toast } from "react-toastify";
import CorouselImages from '../customComponents/carouselImages';
import DeleteIcon from "@mui/icons-material/Delete";
import config from '../config.json';
import { apiRequest } from "../functions/apiRequest";
import { bulkUploadImagesToCloudinary } from "../functions/cloudinaryBulkUpload";
import DraggableImageGrid from '../customComponents/DraggableImageGrid';

const PREFIX = 'editProgram';

const classes = {
  paper: `${PREFIX}-paper`,
  popover: `${PREFIX}-popover`,
  backdrop: `${PREFIX}-backdrop`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.paper}`]: {
    fontFamily: "Raleway",
    fontSize: "18",

    marginTop: 20,
  },

  [`& .${classes.popover}`]: {
    pointerEvents: "none",
  },

  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: "black",
  }
}));

export default function EditProgram() {

  // Initialization imagelist array
  let imagelist = [];
  const { id } = useParams();

  const token = localStorage.getItem("token");

  const checkValid = (data) => {
    if (!data.program_name || String(data.program_name).trim().length === 0) return false;
    if (!data.program_description || String(data.program_description).trim().length === 0) return false;
    if (!data.start_date || String(data.start_date).trim().length === 0) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let finallistimages = imagesListFromDb;
    setSubmitHit(true);
    let badgeImageUrl = null;
    if (checkValid(formData)) {
      if (Object.keys(images).length > 0) {
        let imageArray = await bulkUploadImagesToCloudinary(images);
        finallistimages.push(...imageArray);
      }
      if (Object.keys(badgeImage).length > 0) {
        const badgeUrls = await bulkUploadImagesToCloudinary(badgeImage);
        badgeImageUrl = badgeUrls[0];
        finallistimages.push(badgeImageUrl);
      }
      const programBody = {
        founder_Name: localStorage.getItem("first_name"),
        program_name: formData.program_name,
        program_description: formData.program_description,
        start_date: formData.start_date,
        end_date: formData.end_date,
        impact_int: formData.impact_int,
        impact_units: formData.impact_units,
        impact_char: formData.impact_char,
        redemption: ["Exchange", "Gift", "Certificate"],
        images: finallistimages,
        certificate_description: formData.certificate_description
      };

      if (badgeImageUrl) programBody.badge = badgeImageUrl;

      const data = await apiRequest('put', JSON.stringify(programBody), `/program/update/${id}`, token);
      if (data[0].id) {
        toast.success("Updated successfully");
        window.location.href = `/program/${id}`;
      }
    }
  };

  const deleteProgram = () => {
    fetch(process.env.REACT_APP_API_URL + `/api/program/update/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
      });
    setTimeout(() => {
      window.location.href = "/";
    }, 1500);
  };

  let initialFormData = Object.freeze({
    founder_Name: localStorage.getItem("first_name"),
    program_name: "",
    program_description: "",
    start_date: "",
    impact_int: 100000,
    impact_units: "Hours",
    impact_char: "Tech Scoping",
    redemption: ["Exchange", "Gift", "Certificate"],
  });
  const [formData, updateFormData] = useState(initialFormData);
  const [images, setImages] = useState([]);
  const [badgeImage, setBadgeImage] = useState([]);
  const [imagesListFromDb, setImagesListFromDb] = useState([]);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [submitHit, setSubmitHit] = useState(false);
  const totalMaxLength = parseInt(process.env.REACT_APP_MAX_CHARACTERS_FOR_CERTIFICATE)
  const [maxCertificateDescriptionLength, setMaxCertificateDescriptionLength] = useState(totalMaxLength);
  const handleChange = (e) => {
    let trimmedValue = e.target.value.trim();
    if (e.target.name === 'program_name' && maxCertificateDescriptionLength > 0) {
      setMaxCertificateDescriptionLength(totalMaxLength - trimmedValue.length)
    }
    updateFormData({
      ...formData,
      [e.target.name]: trimmedValue.trim(),
    });
  };
  const handleBadgeImageChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setBadgeImage(filesArray);
  };

  const handleRemoveSelectedBadge = () => {
    setBadgeImage([]);
  };

  // changes will affect on selection of image
  const handleImageChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setImages((prev) => (Array.isArray(prev) ? [...prev, ...filesArray] : filesArray));
  };

  const handleRemoveSelectedFile = (indexToRemove) => {
    setImages((prev) => (Array.isArray(prev) ? prev.filter((_, idx) => idx !== indexToRemove) : []));
  };

  const handleDeleteImageFromDb = async (urlToDelete) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;
    const remainingImages = imagesListFromDb.filter((url) => url !== urlToDelete);
    setImagesListFromDb(remainingImages);

    const programBody = {
      founder_Name: localStorage.getItem("first_name"),
      program_name: formData.program_name,
      program_description: formData.program_description,
      start_date: formData.start_date,
      end_date: formData.end_date,
      impact_int: formData.impact_int,
      impact_units: formData.impact_units,
      impact_char: formData.impact_char,
      redemption: ["Exchange", "Gift", "Certificate"],
      images: remainingImages,
      certificate_description: formData.certificate_description,
      badge: formData.badge
    };
    try {
      await apiRequest('put', JSON.stringify(programBody), `/program/update/${id}`, token);
      toast.success("Image deleted successfully");
    } catch (err) {
      console.error("Failed to delete image", err);
    }
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateFormDataWithApi = (data) => {
    // eslint-disable-next-line
    initialFormData = Object.freeze({
      founder_Name: data.FounderName,
      program_name: data.ProgramName,
      program_description:
        data.ProgramDescription,
      start_date: data.StartDate,
      end_date: data.EndDate,
      redemption: data.Redemption,
      certificate_description: data.CertificateDescription,
      badge: data.Badge
    });
    updateFormData(initialFormData);
  }

  useEffect(() => {
    async function fetchData() {
      const data = await apiRequest('get', null, `/program/events/view?program_id=${id}`);
      for (let i = 0; i < data[0].ProgramImages.length; i++) {
        imagelist.push(data[0].ProgramImages[i]);
      }
      setImagesListFromDb(imagelist);
      updateFormDataWithApi(data[0]);
      setIsLoading(false);
    }
    fetchData();
    // eslint-disable-next-line
  }, []);
  if (!isLoading) {
    return (
      <Grid container style={{ padding: '2vw' }}>
        <Grid item xs={12} sm={12} md={10}>
          <Grid container>
            <Grid item md={1}></Grid>
            <Grid item xs={12} sm={12} md={10}>
              <Typography
                component="h1"
                style={{
                  borderRadius: 20,
                  fontSize: 36,
                  fontFamily: "Raleway",
                }}
              >
                <strong>UPDATE YOUR PROGRAM </strong>
              </Typography>
              <Typography
                component="h1"
                style={{
                  borderRadius: 20,
                  fontSize: 22,
                  marginTop: 10,
                  fontFamily: "Raleway",
                }}
              >
                All fields are required*
              </Typography>
              <Grid item xs={12} md={8}>
                <Typography className={classes.paper}>
                  <strong>What do you want to call your new program?</strong>
                  <Tooltip title="Example: Trash Mafia Kids, Speak Easy " arrow>
                    <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                  </Tooltip>
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  name="program_name"
                  value={formData.program_name}
                  type="title"
                  id="title"
                  size="small"
                  onChange={handleChange}
                  error={submitHit && formData.program_name.length === 0}
                />
              </Grid>
              <Grid item md={8} xs={12}>
                <Typography
                  className={classes.paper}
                  style={{ fontFamily: "Raleway" }}
                >
                  <strong>Describe your social initiative.</strong>
                  <Tooltip
                    title="Example:collecting trash to recycle and raise funds "
                    arrow
                  >
                    <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                  </Tooltip>
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  name="program_description"
                  value={formData.program_description}
                  type="description"
                  id="description"
                  size="small"
                  onChange={handleChange}
                  error={submitHit && formData.program_description.length === 0}
                />
              </Grid>
              <Grid item md={8} xs={12}>
                <Typography
                  className={classes.paper}
                  style={{ fontFamily: "Raleway" }}
                >
                  <strong>Your program tag line or one short sentence to describe your program.</strong>
                  <Tooltip
                    title="Example:Saving the Earth one bin at a time "
                    arrow
                  >
                    <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                  </Tooltip>
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  value={formData.certificate_description}
                  name="certificate_description"
                  type="certificate_description"
                  id="certificate_description"
                  inputProps={{ maxLength: maxCertificateDescriptionLength }}
                  size="small"
                  onChange={handleChange}
                  error={submitHit && formData.certificate_description.length === 0}
                />
              </Grid>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.paper}>
                    <strong>Start date of the program </strong>
                  </Typography>

                  <TextField
                    id="start_date"
                    name="start_date"
                    type="date"
                    size="small"
                    variant="outlined"
                    value={formData.start_date}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={submitHit && formData.start_date.length === 0}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.paper}>
                    <strong>Estimated end date of the program (optional)</strong>
                  </Typography>

                  <TextField
                    id="end_date"
                    name="end_date"
                    type="date"
                    size="small"
                    variant="outlined"
                    value={formData.end_date}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ min: getCurrentDate() }}
                  />
                </Grid>

                <Grid item xs={12} md={10}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8, marginTop: 10 }}>
                    Program Images
                  </Typography>
                  <input
                    type="file"
                    id="images"
                    accept="image/png, image/jpeg, image/jpg"
                    multiple
                    onChange={handleImageChange}
                    style={{ border: "none", outline: "none", cursor: "pointer" }}
                  />

                  {imagesListFromDb && imagesListFromDb.length > 0 && (
                    <DraggableImageGrid
                      items={imagesListFromDb}
                      onReorder={(newOrder) => setImagesListFromDb(newOrder)}
                      onDelete={(idx, url) => handleDeleteImageFromDb(url)}
                    />
                  )}

                  {images && images.length > 0 && (
                    <DraggableImageGrid
                      items={images}
                      onReorder={(newFiles) => setImages(newFiles)}
                      onDelete={(idx) => handleRemoveSelectedFile(idx)}
                    />
                  )}

                  <br />
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8, marginTop: 12 }}>
                    Upload your program logo / badge (Used in Certificate)
                  </Typography>
                  <input
                    type="file"
                    id="badge"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleBadgeImageChange}
                    style={{ border: submitHit && Object.keys(badgeImage).length === 0 ? "1px solid red" : "none", outline: "none", cursor: "pointer" }}
                  />
                  <DraggableImageGrid
                    items={badgeImage || []}
                    onReorder={(newFiles) => setBadgeImage(newFiles)}
                    onDelete={() => handleRemoveSelectedBadge()}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} md={12}>
                <br />
                <br />
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                    color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                    borderRadius: 30,
                    fontFamily: "Raleway",
                    marginBottom: 30,
                  }}
                  onClick={handleSubmit}
                >
                  Update Program
                </Button>{" "}
                &nbsp;
                <Button
                  onClick={handleToggle}
                  style={{ backgroundColor: "red", color: "white", borderRadius: 30, marginBottom: 30 }}
                >
                  <DeleteIcon />{" "}
                </Button>
              </Grid>


              <Backdrop
                className={classes.backdrop}
                open={open}
                onClick={handleClose}
                style={{ textAlign: "center", fontSize: 30 }}
              >
                <Grid
                  container
                  style={{ backgroundColor: "white", borderRadius: 30 }}
                >
                  <Grid item xs={12}>
                    Are you sure you want to delete
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      onClick={() => {
                        deleteProgram();
                      }}
                    >
                      Yes
                    </Button>
                    <Button>No</Button>
                  </Grid>
                </Grid>
              </Backdrop>



            </Grid>
            <Grid item md={1}></Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Root style={{ marginTop: 20, textAlign: "center" }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </Root>
    );
  }

}
